/*--------------------------------------------------------------
# Custom scripts for Related post type block
--------------------------------------------------------------*/

// using slick slider due to Swiper having issues with varying slides to show vs. slide count
var postCarousel = jQuery('.post-slider');

if (postCarousel.length > 0) {
    // set slides to same height
    postCarousel.on('setPosition', function () {
        jQuery(this).find('.post-slider__item').height('auto');
        var slickTrack = jQuery(this).find('.slick-track');
        var slickTrackHeight = jQuery(slickTrack).height();
        jQuery(this).find('.post-slider__item').css('height', slickTrackHeight + 'px');
    });

    // initiate slider
    postCarousel.slick({
        mobileFirst: true,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button class="slick-arrow slick-prev"><span class="visually-hidden">Previous</span><span class="ico icon-arrow-left-simplified" aria-hidden="true"></span></span></button>',
        nextArrow: '<button class="slick-arrow slick-next"><span class="visually-hidden">Next</span><span class="ico icon-arrow-right-simplified" aria-hidden="true"></span></button>',
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}